import { BanksResponse } from "@APP/types";
import { createReducer } from "deox";

import {
  clearRtpState,
  setBanksLoading,
  setBanksError,
  setBanksSuccess,
  setSelectedBank,
} from "../actions";

export interface BanksState {
  loading: boolean;
  error: boolean;
  banks: BanksResponse[] | null;
  selectedBank: string | null;
}

const defaultState: BanksState = {
  loading: true,
  error: false,
  banks: null,
  selectedBank: null,
};

const banksReducer = createReducer(defaultState, (handleAction) => [
  handleAction(setBanksLoading, (state, { payload }) => ({
    ...state,
    loading: payload,
    error: false,
  })),
  handleAction(setBanksSuccess, (state, { payload }) => ({
    ...state,
    banks: payload,
    error: false,
    loading: false,
  })),
  handleAction(setBanksError, (state, { payload }) => ({
    ...state,
    banks: null,
    loading: false,
    error: payload,
  })),
  handleAction(setSelectedBank, (state, { payload }) => ({
    ...state,
    selectedBank: payload,
  })),
  /**
   * The chosen bank belongs to the payment session being cleared, so it must go
   * with it. The fetched bank list is deliberately kept - it is not tied to a
   * particular request and dropping it would flicker the bank select screen.
   */
  handleAction(clearRtpState, (state) => ({
    ...state,
    selectedBank: null,
  })),
]);

export default banksReducer;
